import { render, staticRenderFns } from "./DataImportStudents.vue?vue&type=template&id=91d73996&scoped=true&"
import script from "./DataImportStudents.vue?vue&type=script&lang=js&"
export * from "./DataImportStudents.vue?vue&type=script&lang=js&"
import style0 from "./DataImportStudents.vue?vue&type=style&index=0&id=91d73996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d73996",
  null
  
)

export default component.exports